import React from 'react';
import { Transition } from '@headlessui/react';
import {
  XCircleIcon,
  CheckCircleIcon,
  ExclamationCircleIcon,
  InformationCircleIcon,
} from '@heroicons/react/24/solid';

const toastTypes = {
  success: {
    icon: CheckCircleIcon,
    bg: 'bg-green-600',
    text: 'text-white',
  },
  error: {
    icon: ExclamationCircleIcon,
    bg: 'bg-red-600',
    text: 'text-white',
  },
  neutral: {
    icon: InformationCircleIcon,
    bg: 'bg-zinc-900',
    text: 'text-white',
  },
};

const Toast = ({ id, message, type = 'neutral', onClose }) => {
  const { icon: Icon, bg, text } = toastTypes[type] || toastTypes.neutral;

  return (
    <Transition
      appear
      show
      as="div"
      enter="transition ease-out duration-200"
      enterFrom="opacity-0 translate-y-2"
      enterTo="opacity-100 translate-y-0"
      leave="transition ease-in duration-150"
      leaveFrom="opacity-100 translate-y-0"
      leaveTo="opacity-0 translate-y-2"
      className={`pointer-events-auto w-full max-w-sm rounded-xl ${bg} ${text} shadow-lg ring-1 ring-black/10`}
      role="status"
    >
      <div className="flex items-center gap-3 px-4 py-3">
        <Icon className="h-5 w-5" />
        <span className="text-sm font-medium flex-1">{message}</span>
        <button
          onClick={onClose}
          className="opacity-80 hover:opacity-100"
          aria-label="Dismiss"
        >
          <XCircleIcon className="h-5 w-5" />
        </button>
      </div>
    </Transition>
  );
};

export default Toast;
